<template>
  <v-img
    src="/img/auth-laptop-background.svg"
    lazy-src="/img/auth-laptop-background.svg"
    width="60%"
    max-height="100vh"
    content-class="laptop-background"
    class="auth-illustration"
    cover
  >
    <v-img
      :src="laptopAndLogosSrc"
      :lazy-src="laptopAndLogosSrc"
      image-class="laptop-and-logos-img"
      max-height="72.5%"
    />
  </v-img>
</template>

<script>
  export default {
    computed: {
      laptopAndLogosSrc() {
        return this.$vuetify.theme.global.name === 'dark'
          ? '/img/auth-laptop-and-logos-dark.svg'
          : '/img/auth-laptop-and-logos.svg';
      },
    },
  };
</script>

<style lang="scss">
  @use '../../../assets/styles/theme' as *;

  .laptop-background {
    padding-top: 115px;
  }

  .v-theme--dark .auth-illustration img:not(.laptop-and-logos-img) {
    filter: invert(1) hue-rotate(180deg);
  }
</style>
